var map = {
	"./About.vue": [
		6644,
		644
	],
	"./Contact.vue": [
		7233
	],
	"./HomeView.vue": [
		4101
	],
	"./Portfolio.vue": [
		8025
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;